export default __webpack_public_path__ + "static/media/text-images.png?.fbfb5807";